import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useSession } from '@/context/SessionContext'
import AuthLoadingShell from './AuthLoadingShell'
import { buildLoginRedirect } from './authRouting'

export default function ProtectedRoute() {
  const { user, loading } = useSession()
  const location = useLocation()

  if (loading) return <AuthLoadingShell />
  if (!user) return <Navigate to={buildLoginRedirect(location)} replace />

  return <Outlet />
}
